var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 10,
    fill: "#F7DBB3",
    fillOpacity: 0.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.9531 21.6328L30 15.0234L18.0469 21.6328L25.6406 25.8516C26.2031 25.2891 26.8594 24.8438 27.6094 24.5156C28.3594 24.1875 29.1562 24.0234 30 24.0234C30.8438 24.0234 31.6406 24.1875 32.3906 24.5156C33.1406 24.8438 33.7969 25.2891 34.3594 25.8516L41.9531 21.6328ZM26.9766 30C26.9766 29.1562 27.2578 28.4531 27.8203 27.8906C28.4297 27.2812 29.1562 26.9766 30 26.9766C30.8438 26.9766 31.5469 27.2812 32.1094 27.8906C32.7188 28.4531 33.0234 29.1562 33.0234 30C33.0234 30.8438 32.7188 31.5703 32.1094 32.1797C31.5469 32.7422 30.8438 33.0234 30 33.0234C29.1562 33.0234 28.4297 32.7422 27.8203 32.1797C27.2578 31.5703 26.9766 30.8438 26.9766 30ZM28.5234 44.1328L16.5 37.5234V24.2344L24.1641 28.4531C24.0703 28.9219 24.0234 29.4375 24.0234 30C24.0234 31.4062 24.4453 32.6484 25.2891 33.7266C26.1328 34.8047 27.2109 35.5078 28.5234 35.8359V44.1328ZM31.4766 44.1328V35.8359C32.7891 35.5078 33.8672 34.8047 34.7109 33.7266C35.5547 32.6484 35.9766 31.4062 35.9766 30C35.9766 29.4375 35.9297 28.9219 35.8359 28.4531L43.5 24.2344V37.5234L31.4766 44.1328Z",
    fill: "#FF9900"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardLogo);
export default __webpack_public_path__ + "static/media/card-logo.2218774b231208438bd072cb810e06f1.svg";
export { ForwardRef as ReactComponent };